import { render } from "./MyIcon.vue?vue&type=template&id=76599165&style=color%3Ablue"
import script from "./MyIcon.vue?vue&type=script&lang=js"
export * from "./MyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__